import { render } from "./geo.vue?vue&type=template&id=9c8aaa40&scoped=true"
import script from "./geo.vue?vue&type=script&lang=js"
export * from "./geo.vue?vue&type=script&lang=js"

import "./geo.vue?vue&type=style&index=0&id=9c8aaa40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c8aaa40"]])

export default __exports__